import localforage from "localforage";
import React, { useContext, useMemo, useState } from "react";
import { setCurrentCompanyId } from "./apis/getCurrentCompanyId";

export const GlobalProviderContext = React.createContext({});
export const GlobalActionContext = React.createContext({});

let currentCompanyId;
let currentCompanyName;

export const useGlobalState = () => {
  return useContext(GlobalProviderContext);
};

export const useGlobalDispatch = () => {
  return useContext(GlobalActionContext);
};

export const getCurrentCompanyId = async () => {
  return currentCompanyId || (await localforage.getItem("currentCompanyId"));
};

export const getCurrentCompanyName = async () => {
  return (
    currentCompanyName || (await localforage.getItem("currentCompanyName"))
  );
};

export default ({ children }) => {
  const [state, setCurrentState] = useState({});

  const action = useMemo(() => {
    return {
      setCurrentCompany: async (id, name) => {
        await localforage.setItem("currentCompanyId", id);
        await localforage.setItem("currentCompanyName", name);
        currentCompanyId = id;
        currentCompanyName = name;
        setCurrentCompanyId(id);
        setCurrentState(preState => ({
          ...preState,
          currentCompanyId: id,
          currentCompanyName: name
        }));
      }
    };
  }, []);

  return (
    <GlobalProviderContext.Provider value={state}>
      <GlobalActionContext.Provider value={action}>
        {children}
      </GlobalActionContext.Provider>
    </GlobalProviderContext.Provider>
  );
};
